import type { LoyaltyMessageDto } from "../../types/LoyaltyMessageDto";
import type { LoyaltyMessageEntity } from "../../types/LoyaltyMessageEntity";

export const LoyaltyMessageDtoToEntity = ({ ...rest }: Readonly<LoyaltyMessageDto>): LoyaltyMessageEntity => {
    return { ...rest };
};
